import { render } from "./Advanture.vue?vue&type=template&id=d1fb32f2&scoped=true"
import script from "./Advanture.vue?vue&type=script&lang=js"
export * from "./Advanture.vue?vue&type=script&lang=js"

import "./Advanture.vue?vue&type=style&index=0&id=d1fb32f2&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fb32f2"]])

export default __exports__